import { useQuery } from '@tanstack/react-query';
import { post } from 'app/shared/utils/fetchr';
import { ALERT_QUERY_KEYS } from 'app/modules/alerts/queries/keys';
import { PaginationPayload } from 'app/shared/pagination/models';
import { GetTransactionsResponse } from 'app/modules/transactions/responses';
import { useSelector } from 'react-redux';
import { selectHasReadAlertsPermission } from 'app/modules/session/selectors';

export const useFetchAlertHitTxnEvents = (
  id: number,
  pagination: PaginationPayload,
) => {
  const hasReadAlertsPermission = useSelector(selectHasReadAlertsPermission);
  return useQuery<GetTransactionsResponse>({
    queryKey: ALERT_QUERY_KEYS.alertHitTxnEvents(id, pagination),
    queryFn: () => post(`/alert-hits/${id}/transactions`, pagination),
    enabled: hasReadAlertsPermission && pagination.limit > 0,
  });
};
